import {Component, Inject, OnInit} from '@angular/core';
import {ToastrService} from "ngx-toastr";
import {DataService} from "../../../services/data.service";
import {GlobalConstants} from "../../../common/global-constants";
import {AuthenticationService} from "../../../services/authentication.service";
import {CommonUtils} from "../../../utils/common.utils";

@Component({
  selector: 'app-my-requests',
  templateUrl: './my-requests.component.html',
  styleUrls: ['./my-requests.component.scss']
})
export class MyRequestsComponent implements OnInit {

  fetchAllTransitTimeRequestsUrl: string = GlobalConstants.FETCH_ALL_TRANSIT_TIME_REQUESTS_ENDPOINT;

  loading = false;
  allRequests = [];
  filteredRequests = [];

  // Filter values
  selectedStatuses: string[] = ['IN_PROGRESS', 'PENDING_APPROVAL', 'PENDING_VALIDATION', 'PENDING_UPDATE', 'PENDING', GlobalConstants.REQUEST_STATUS_REJECTED];
  countryCodeFilter = '';
  transitTimeTypeFilter = '';

  // Distinct values for filter dropdowns
  distinctStatuses: string[] = ['IN_PROGRESS', 'PENDING_APPROVAL', 'PENDING_VALIDATION', 'PENDING_UPDATE', 'PENDING', GlobalConstants.REQUEST_STATUS_COMPLETED, GlobalConstants.REQUEST_STATUS_REJECTED];
  distinctCountryCodes: string[] = [];
  distinctTransitTimeTypes: string[] = [];

  user: any = {};

  constructor(@Inject('RequestsService') private requestsService,
              @Inject('CommonUtils') public readonly commonUtils: CommonUtils,
              @Inject('AuthenticationService') private readonly authenticationService: AuthenticationService,
              private toastrService: ToastrService,
              private dataService: DataService) {
  }

  ngOnInit() {
    this.user = this.authenticationService.getUserDetails();
    this.fetchRequests();
  }

  fetchRequests() {
    this.loading = true;
    const requestBody: any = {
      createdBy: this.user[GlobalConstants.ALIAS],
      requestStatusFilter: this.selectedStatuses.length > 0 ? this.selectedStatuses : undefined
    };

    this.requestsService.put(this.fetchAllTransitTimeRequestsUrl, requestBody).subscribe(data => {
      this.loading = false;
      this.allRequests = data[GlobalConstants.TRANSIT_TIME_REQUESTS_RESPONSE_KEY] || [];
      this.buildFilterOptions();
      this.applyFilters();
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }

  buildFilterOptions() {
    const arc = this.commonUtils.getArc();
    const arcFiltered = this.allRequests.filter(r =>
      r[GlobalConstants.ARC] == undefined || r[GlobalConstants.ARC] == arc
    );

    this.distinctCountryCodes = [...new Set(arcFiltered.map(r => r.fromCountryCode).filter(Boolean))] as string[];
    this.distinctTransitTimeTypes = [...new Set(arcFiltered.map(r => r.transitTimeType).filter(Boolean))] as string[];

    // Reset client-side filters if their current value is no longer valid
    if (this.countryCodeFilter && !this.distinctCountryCodes.includes(this.countryCodeFilter)) {
      this.countryCodeFilter = '';
    }
    if (this.transitTimeTypeFilter && !this.distinctTransitTimeTypes.includes(this.transitTimeTypeFilter)) {
      this.transitTimeTypeFilter = '';
    }
  }

  applyFilters() {
    const arc = this.commonUtils.getArc();
    this.filteredRequests = this.allRequests.filter(r => {
      if (r[GlobalConstants.ARC] != undefined && r[GlobalConstants.ARC] != arc) return false;
      if (this.countryCodeFilter && r.fromCountryCode !== this.countryCodeFilter) return false;
      if (this.transitTimeTypeFilter && r.transitTimeType !== this.transitTimeTypeFilter) return false;
      return true;
    });
  }

  onStatusFilterChange(selectedStatuses: string[]) {
    this.selectedStatuses = selectedStatuses;
    this.fetchRequests();
  }

  clearFilters() {
    this.selectedStatuses = ['IN_PROGRESS', 'PENDING_APPROVAL', 'PENDING_VALIDATION', 'PENDING_UPDATE', 'PENDING', GlobalConstants.REQUEST_STATUS_REJECTED];
    this.countryCodeFilter = '';
    this.transitTimeTypeFilter = '';
    this.fetchRequests();
  }
}
